/**============================================================
*   [setVers]
============================================================*/
document.addEventListener('DOMContentLoaded', () => {
  const headerElem = document.getElementById('header-navigation');
  let vw = window.innerWidth;

  //1vhの値（iOSのアドレスバー対策）
  window.addEventListener('load', setViewHeight, true);
  window.addEventListener('scroll', setViewHeight, true);
  window.addEventListener('resize', () => {
    // 画面の横幅のサイズ変動があった時のみ高さを再計算する
    if (vw === window.innerWidth) {
      return;
    }
    vw = window.innerWidth;
    setViewHeight();
  });

  function setViewHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }

  //ヘッダーの高さ
  if(headerElem !== null){
    window.addEventListener('load', setHeaderHeight, true);
    window.addEventListener('resize', setHeaderHeight, true);
  }
  function setHeaderHeight() {
    document.documentElement.style.setProperty('--header-H', headerElem.getBoundingClientRect().height+'px')
  }

  //fixed要素の横スクロール用X値
  window.addEventListener('load', setHeaderX, true);
  window.addEventListener('scroll', setHeaderX, true);
  window.addEventListener('resize', setHeaderX, true);
  function setHeaderX() {
    document.documentElement.style.setProperty('--header-X', -window.scrollX+'px')
  }
});
